/**
 * 매장 좋아요/알림 공용 GraphQL 뮤테이션.
 * home, store, like 등 여러 route에서 재사용하므로 src/api에 둔다.
 * @see docs/file-structure.md "공용 gql vs route api" 기준
 */
import { gql } from "@apollo/client";

export const LIKE_STORE = gql`
  mutation LikeStore($storeId: Int!) {
    likeStore(storeId: $storeId) {
      id
      userId
      storeId
      createdAt
    }
  }
`;

export const CANCEL_LIKE = gql`
  mutation CancelLike($storeId: Int!) {
    cancelLike(storeId: $storeId) {
      id
      userId
      storeId
      createdAt
    }
  }
`;
